import { MenuItem } from "@mui/material";
import { useUpdateUserMutation } from "../../../api/userApiSlice";
import { RowActionProps } from "../../../components/LassoGrid";

const PendingActions = (props: RowActionProps) => {
    const [ updateUser ] = useUpdateUserMutation();

    const approveUser = (event: any) => {
        const activeUntil = new Date();
        activeUntil.setMonth(activeUntil.getMonth() + 24);
        const updatedFields = {
            PendingApproval: false,
            GeneratePassword: true,
            ActiveUntil: activeUntil.toISOString().split('T')[0],
        };
        updateUser({
            userID: props.rowData.ID,
            fields: updatedFields
        });
        props.close(event);
    }

    const rejectUser = (event: any) => {
        const updatedFields = {
            Active: false
        }
        updateUser({
            userID: props.rowData.ID,
            fields: updatedFields
        });
        props.close(event);
    }

    return (
        <>
            <MenuItem onClick={approveUser}>Approve</MenuItem>
            <MenuItem onClick={rejectUser}>Reject</MenuItem>
        </>
    )

    // return (
    //     <>
    //         <Button
    //             variant="contained"
    //             color="success"
    //             size="small"
    //             onClick={() => approveUser(true)}
    //         >
    //             Approve
    //         </Button>
    //         <Button
    //             variant="contained"
    //             color="error"
    //             size="small"
    //             onClick={() => approveUser(false)}
    //         >
    //             Deny
    //         </Button>
    //     </>
    // )
}

export default PendingActions;